import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const SETTING_SIDENAV_LINKS = new InjectionToken<void>("SETTING_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "system-settings",
        label: "SETTINGS.ITEMS.SYSTEM_SETTINGS",
        routerLink: "/settings/system-settings",
        icon: "settings-page",
        permissions: COMMON_GUARD_OPTIONS.SYSTEM_SETTINGS.VIEW.permissions,
      },
    ]);
  },
});
